<template>
<div>
  <Modal v-model="modal" :title="$t('PB_Select_Employee_Search')" width="88%" :closable='false' :mask-closable="false"><!-- 选择员工 -->
    <Form :model="modalFormItem" :label-width="100" label-position="left">
      <Row :gutter="10">
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('BU')"><!-- 业务单元 -->
            <Select v-model="modalFormItem.businessUnit" clearable style="width:100%">
              <Option v-for="item in businessUnitList" :value="item.ch_value" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Department')"><!-- 大区 -->
            <Select v-model="modalFormItem.department" clearable style="width:100%">
              <Option v-for="item in departmentList" :value="item.ch_value" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Funciton')"><!-- 职能 -->
            <Select v-model="modalFormItem.postFun" clearable style="width:100%">
              <Option v-for="item in functionList" :value="item.ch_value" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Management_Level')"><!-- 管理层级 -->
            <Select v-model="modalFormItem.hrmanage" clearable style="width:100%">
              <Option v-for="item in ManagementLevel" :value="item.ch_value" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Position')"><!-- 职位 -->
            <Input v-model="modalFormItem.position" />
            <!-- <Select v-model="modalFormItem.position" clearable style="width:100%">
              <Option v-for="item in positionList" :value="item.ch_value" :key="item.code">{{item.ch_value}}</Option>
            </Select> -->
          </FormItem>
        </Col>
        <Col  :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Employee_Code')"><!-- 员工号 -->
            <Input type="text" v-model="modalFormItem.empCode" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Name')"><!-- 姓名 -->
            <Input type="text" v-model="modalFormItem.userName" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('English_Name')"><!-- 英文名 -->
            <Input type="text" v-model="modalFormItem.eName" />
          </FormItem>
        </Col>
          <Col  :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Line_Manager')"><!-- 直接上级 -->
                <Input type="text" v-model="modalFormItem.dirSupName" search enter-button clearable readonly @on-clear="dirClear()" @on-search="dirSearch"/>
            </FormItem>
            <p style="font-size:12px;color:red;margin-top:-15px;margin-bottom:10px">{{$t('PB_longText31')}}<!-- *默认显示选择人员的所有下属，如需进一步筛选，请选择汇报层级 --></p>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
              <FormItem :label="$t('Reporting_Line')"><!-- 汇报层级 -->
                  <Select v-model="modalFormItem.levelNum" multiple clearable :disabled="levelDisabledState">
                      <Option v-for="item in Level" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                  </Select>
              </FormItem>
          </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Carlsberg_Band')"><!-- 嘉士伯级别 -->
            <Select v-model="modalFormItem.hcmBand" clearable style="width:100%">
              <Option v-for="item in Band" :value="item.ch_value" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
            </Select>
          </FormItem>
        </Col>
        
        <Col :xs="24" :sm="24" :md="12" :lg="2">
          <FormItem style="display: flex;justify-content: end;">
            <Button @click="pageInfo.pageNo=1,getData()"><!-- 检 索 -->{{$t('Search')}}</Button>
          </FormItem>
        </Col>
        
      </Row>
    </Form>
    <Table highlight-row border :columns="modelColumns" :data="modelData" @on-select-cancel="TableSelectCancelRow" 
          @on-select-all-cancel="cancelAll"  @on-select-all="selsetAll" @on-select="peoOnSelectRow"
          ref="selectiona" :loading="loading">
          </Table>
    
    <div style="display: flex;justify-content: end;margin-top: 30px;">
      <Page :total="total" :current="pageInfo.pageNo" @on-change="pageChange"></Page>
    </div>

    <div slot="footer">
      <Button type="text" @click="handleConfirm"><!-- 确认 -->{{$t('Confirm')}}</Button>           
      <Button type="text" @click="handleCancle"><!-- 取消 -->{{$t('Cancel')}}</Button>  
    </div>
  </Modal>
  <DirModalComponent ref="DirModalComponent" @selectRow="dirSelect"></DirModalComponent>
  </div>
</template>

<script>
import axios from 'axios'
import EventBus from '@/util/eventBus.js'
import DirModalComponent from "../components/modalComponents/DirModalComponent.vue";
export default {
  components:{DirModalComponent},
  data() {
    return {
      loading:false,
      modal: false,
      modalFormItem: {},
      
      modelData: [],
      pageInfo: {
          itemCount: 0,
          pageNo: 1,
          pageSize: 10,
      },
      total: 0,
      list:[],
      positionList:[],
      ApplyStatus :[],
      departmentList:[],
      functionList:[],
      businessUnitList :[],
      ManagementLevel:[],
      Level:[],
      BeQuit:[],
      selectList:[],
      Band:[],
      state:false,
      rowItem:{},
      targetkey:'',
      userType:'',
      id:'',
      nullJobNum:0,
      btnShow:false,
      beEnd:'',
      jobId:'',
      levelDisabledState:true,
    };
  },
  computed:{
    modelColumns(){
        return [
          {
            type: "selection",
            minWidth: 60,
            align: "center"
          },{
            title: this.$t('Employee_Code'),/* 员工号 */
            key: "empCode",
            align: "center",
            minWidth: 200
          },{
            title: this.$t('Name'),/* 姓名 */
            key: "userName",
            align: "center",
            minWidth: 200
          },{
            title: this.$t('English_Name'),/* 英文名 */
            key: "userEName",
            align: "center",
            minWidth: 200
          },{
            title: this.$t('BU'),/* 业务单元 */
            key: "businessUnit",
            align: "center",
            minWidth: 200
          }, {
            title: this.$t('Department'),/* 大区 */
            key: "department",
            align: "center",
            minWidth: 200
          }, {
            title: this.$t('Funciton'),/* 职能 */
            key: "postFun",
            align: "center",
            minWidth: 200
          }, {
            title: this.$t('Position_Name_Chinese'),/* 职位名称（中文） */
            key: "positionCTitle",
            align: "center",
            minWidth: 200
          },{
            title: this.$t('Position_Name_English'),/* 职位名称（英文） */
            key: "positionETitle",
            align: "center",
            minWidth: 200
          },{
            title: this.$t('Line_Manager'),/* 直线上级 */
            key: "dirSupName",
            align: "center",
            minWidth: 200
          },{
            title: this.$t('PB_Resign_Date'),/* 离职日期 */
            key: "quitDate",
            align: "center",
            minWidth: 200
          }
      ]
    },
    lang(){
      return this.$store.getters.selectLangeData
    }
  },
  created(){
    this.getData()
    this.getListData()
  },
  watch: {
      selectList: {
        handler(newVal, oldVal) {
          newVal.forEach(res => {
            this.modelData.forEach((el, index) => {
              el._checked = false
              if (el.serialnumber === res.serialnumber) {
                  this.$refs.selectiona.objData[index]._isChecked = true
                }
            })
          })
        },
        deep: true,
        immediate: true
      }
  },
  methods: {
    getListData(){
        axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
            if (res) {
                this.positionList=res.positionList
                this.departmentList=res.departmentList
                this.businessUnitList=res.businessUnitList
                this.Level=res.Level
                this.Band=res.Band
                this.functionList=res.functionList
                this.BeQuit=res.BeQuit
                this.ManagementLevel=res.ManagementLevel
            }
        })
    },
    getData(){
      let obj={ 
        userType:this.userType,
        id:this.id,
        ...this.modalFormItem,
        ...this.pageInfo,
        jobId:this.jobId,
        beJob:'1'
      }
      this.loading=true
      axios.post("/TalentInventory/selectUserList", obj).then((res) => {
        this.loading=false
          if (res) {
              this.modelData=res.data
              // this.modelData.forEach(el => {
              //   el._checked=false
              // })
              this.$nextTick(() => {
                this.selectList.forEach(res => {
                  this.modelData.forEach((el, index) => {
                    el._checked = false
                    if (el.serialnumber === res.serialnumber) {
                        this.$refs.selectiona.objData[index]._isChecked = true
                      }
                  })
                })
              })
              this.total = parseInt(res.pageInfo.total)
          }
      })
    },
    targetItemChange(row, index, key) {
      key && this.$set(this.columnsData[index], key, row[`${key}`]);
    },
  
    pageChange(val){
        this.pageInfo.pageNo = val;
        this.getData()
    },
    handleConfirm(){
      // this.modelColumns.splice(0, 1);
      this.modal=false
      this.$emit('onSelectList',JSON.parse(JSON.stringify(this.selectList)))
      this.$nextTick(() => {
        this.$refs.selectiona.selectAll(false);
        this.pageInfo.pageNo=1
      })
    },
    handleCancle(){
      // this.modelColumns.splice(0, 1);
      this.modal=false
      this.$nextTick(() => {
        this.$refs.selectiona.selectAll(false);
        this.pageInfo.pageNo=1
      })
    },
    TableSelectCancelRow(selection, row){
        this.selectList.forEach((el,index) => {
            if(el.serialnumber==row.serialnumber){
                this.selectList.splice(index,1)
            }
        })
    },
    peoOnSelectRow(selection,row) {
        if (!this.selectList.includes(row.serialnumber)) {
            this.selectList.push(row)
        }
    },
    selsetAll(selection){
        this.modelData.forEach(el => {
            this.selectList.push(el)
        })
        let map = new Map();
        for (let item of this.selectList) {
            map.set(item.serialnumber, item);
        }
        this.selectList = [...map.values()];
    },
    cancelAll(selection){
        this.modelData.forEach(row =>{
            this.selectList.forEach((el,index) => {
                if(el.serialnumber==row.serialnumber){
                    this.selectList.splice(index,1)
                }
            })
        })
    },
    dirSearch(){
        this.$refs.DirModalComponent.modalShow=true
    },
    dirSelect(item){
        let json=JSON.parse(item)
        this.modalFormItem.dirSupName=json.userName
        this.modalFormItem.dirSupSerialnumber=json.dirSupSerialnumber
        this.$set(this.modalFormItem,'dirSupName',json.userName)
        this.levelDisabledState=false
    },
    dirClear(){
        this.modalFormItem.dirSupSerialnumber=''
        this.levelDisabledState=true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PeopleBoardComponents/PDselectPeopleEmp.vue